<app-loading [isLoading]="!progressService.selectedFestival()">
  <div class="p-4 flex flex-col gap-4">
    <h1 class="text-2xl leading-snug">Datumsauswahl</h1>
    <p>Wählen Sie einen Termin für Ihre Reservierung
      beim {{ progressService.selectedFestival()!.title_public }}.</p>
    <div class="bg-white rounded-lg p-2">
      <span class="text-sm">{{ progressService.selectedFestival()!.valid_from_date | date:'dd. MMMM' }}
        bis {{ progressService.selectedFestival()!.valid_to_date | date:'dd. MMMM yyyy' }}</span>
      <div class="grid grid-cols-7 gap-y-4 gap-x-1 text-center mt-2 justify-center">
        <span>Mo</span>
        <span>Di</span>
        <span>Mi</span>
        <span>Do</span>
        <span>Fr</span>
        <span>Sa</span>
        <span>So</span>
        <span class="col-span-7 w-full border-[0.5px] border-benzGrey-100"></span>
        <!-- one of: col-span-0 col-span-1 col-span-2 col-span-3 col-span-4 col-span-5 col-span-6 -->
        <span class="col-span-{{firstCalendarDayWeekday()-1}}"></span>
        <div *ngFor="let calendarDay of calendarDays()" class="flex flex-col items-center">
          <a role="button" [class.hover:bg-benzGrey-150]="calendarDay.availableDaytypes.length > 0"
             [class.text-benzGrey-75]="(calendarDay.date | date:'yyyy-MM-dd':'UTC') === progressService.selectedDate()"
             [class.hover:text-benzGrey-900]="(calendarDay.date | date:'yyyy-MM-dd':'UTC') === progressService.selectedDate()"
             [class.bg-benzGrey-100]="calendarDay.availableDaytypes.length > 0"
             [class.bg-benzGrey-900]="(calendarDay.date | date:'yyyy-MM-dd':'UTC') === progressService.selectedDate()"
             (keyup.enter)="selectDay(calendarDay)"
             (click)="selectDay(calendarDay)"
             class="w-10 h-10 flex justify-center items-center rounded-full relative">{{ calendarDay.date.getUTCDate() }}</a>
          <span class="text-sm my-1">{{ calendarDay.date | date:'MMM':'UTC' | uppercase }}</span>
        </div>
      </div>
    </div>
    @if (availableDayTypesForSelectedDate().length > 0) {
      <div class="flex flex-col gap-4 mt-4">
        <h1 class="text-2xl leading-snug">Zeitfenster</h1>
        <p>Bitte wählen Sie das gewünschte Zeitfenster aus</p>
        @for (daySlot of availableDayTypesForSelectedDate(); track daySlot.type) {
          <button
            class="text-left cursor-pointer bg-white rounded-xl p-3 justify-between items-center flex gap-2 border-2 border-benzGrey-900 hover:border-benzGrey-400"
          (click)="selectDayType(daySlot.type)"
          >
            <div class="flex-col gap-2 flex">
            <h2 class="font-bold">{{ translateDayslot(daySlot.type, availableDayTypesForSelectedDate().length) }}</h2>
            <p>Von {{ daySlot.from | date:'HH:mm' }} bis {{ daySlot.to | date:'HH:mm' }} Uhr</p>
            </div>
            <div>
              <span>Ab {{ daySlot.minCost | currency:'EUR' }}</span>
            </div>
          </button>
        }
        <span class="pb-4 -mb-4" #endOfSlotList></span>
      </div>
    }
  </div>
</app-loading>

